import React from "react";
import Card from "react-bootstrap/Card";
import { useTranslation } from "react-i18next"; // Importar el hook

const PriestBubble = ({ text }) => {
  const { t } = useTranslation(); // Usar el hook useTranslation

  return (
    <Card className="priest-bubble">
      {t("priestbubble.priest")}: {text}
    </Card>
  );
};

export default PriestBubble; // Exportar directamente el componente
